<template>
    <div class="fill-height">
        <v-card class="fill-height rounded-lg">
            <v-card-text class="fill-height">
				<v-dialog v-model="dialog" width="400" class="rounded-lg">
					<v-card class="rounded-lg pa-1">
						<v-form ref="form" @submit.prevent="addOrEditItemToRow">
							<v-card-title class="pb-3 Urbanist-font">
								{{ taskId ? 'Edit Task' : 'Add Task'}}
							</v-card-title>
							<v-card-text>
								<v-row class="px-2">
									<v-col v-if="0" cols="12" class="pb-0 pt-2 px-0">
										<bee-date-picker
											v-model="taskDate"
											input-label="End date"
											input-format-order="DD-MM-YYYY"
											dense
											class="rounded-lg"
											hide-details
											:menu-picker="menuPickerEnd"
											:active-picker.sync="activePickerEnd"
											months-over-max="1"
											:input-props="{
												readonly: view,
												outlined: true,
												filled: true,
												dense: true,
												clearable: true,
												prependIcon: 'mdi-calendar-plus'
											}"
											:readonly="view"
										></bee-date-picker>
									</v-col>
									<v-col cols="12" class="pb-0 pt-2 px-0">
										<!-- {{userTypeUser === userType.Developer ? currentUserProjects : allProjects}} -->
										<v-autocomplete
											v-model="project"
											:items="allProjects"
											item-text="name"
											item-value="id"
											dense
											outlined
											filled
											hide-details
											label="Project Name"
											class="rounded-lg"
											:readonly="view"
										/>
									</v-col>

									<v-col cols="12" class="pb-0 pt-2 px-0">
										<v-text-field 
											v-model.number="taskNo"
											label="Task No (on Plan)" 	
											dense
											outlined
											filled
											hide-details 
											class="rounded-lg"
											:rules="rules.requiredAsNumber"
											:readonly="view"
										/>
									</v-col>
								
									<!-- Duration -->
									<v-col cols="12" class="pb-0 pt-2 px-0">
										<v-text-field 
											v-model.number="hours"
											label="Hours" 	
											dense
											outlined
											filled
											class="rounded-lg"
											:rules="rules.requiredAsNumber && [val => val <= 4 ]"
											hide-details="auto"
											:readonly="view"
										/>
									</v-col>

									<v-col cols="12" class="pb-0 pt-2 px-0">
										<!-- :rows="task != null && task.length < 60 ? 2 : 'auto'" -->
										<!-- :rules="rule" -->
										<!-- {{ task.includes('ا') || task.includes('ب') }} -->
										<v-textarea
											v-model="task"
											:value="task"
											counter
											dense
											filled
											label="Task description"
											dir="auto"
											:readonly="view"
										/>
									</v-col>
								</v-row>
							</v-card-text>
							<v-card-actions class="pt-1">
								<v-spacer />
								<v-btn
									v-if="!view"
									@click="addOrEditItemToRow"
									:color="taskId ? 'edit-color' : 'success-light'"
									class="white--text rounded-lg text-none"
									:loading="submitLoading"
								>
									<v-icon small color="white"> 
										{{ taskId ? 'mdi-pencil' : 'mdi-plus'}} 
									</v-icon>
									{{ taskId ? 'Edit': 'Add' }}
								</v-btn>

								<v-btn
									@click="dialog = false"
									class="rounded-lg text-none"
									color="alert-color white--text"
									:disabled="loading"
								>
									Cancel 
								</v-btn>
							</v-card-actions>
						</v-form>
					</v-card>
				</v-dialog>

				<!-- delete dialog -->
				<v-dialog v-model="deleteDialog" width="400">
					<v-card>
						<v-card-title>
							Delete Task
						</v-card-title>
						<v-card-text>
							Are you sure you want to delete this task ?
						</v-card-text>
						<v-card-actions>
							<v-spacer />
							<v-btn
								color="alert-color white--text"
								class="rounded-lg text-none"
								:loading="submitLoading"
								@click="deleteTask()"
							>
								Yes
							</v-btn>
							<v-btn
								@click="deleteDialog = false"
								class="rounded-lg text-none"
								:disabled="submitLoading"
							>
								No
							</v-btn>
						</v-card-actions>
					</v-card>
				</v-dialog>

                <v-btn
                    color="success-light white--text"
                    class="text-none mb-1"
					@click="dialog = true"
                >
                    <v-icon class="pe-2"> mdi-plus-circle </v-icon>
                    Add Task 
                </v-btn>
                <!-- card -->
                <v-col 
                    class="text-center d-flex flex-wrap py-1 d-flex" 
                    :class="{
                        'flex-wrap': $vuetify.breakpoint.mdAndDown
                    }" 
                    align-self="center" 
                >

                    <div
						v-for="(task, r) in tasks" 
                        :key="r"
                        :class="{ 
                            'task-card-done': task.isDone,
                            'task-card': !task.isDone && $vuetify.breakpoint.lgAndUp,
                            'h-auto my-1': $vuetify.breakpoint.lgAndDown,
                            'my-grey': !task.isDone,
                            'w-100': $vuetify.breakpoint.mdAndDown
                        }"
                        class="my-0 pa-1 mx-1 rounded-lg" 
                    >
                        <v-col class="h-100 pt-0 d-flex flex-column">
                            <v-row class="mt-0 pt-0">
                                <v-col cols="7" class="py-0 text-start ">
                                    <span 
                                        class=" fs-12" 
                                        :class="{
                                            'white--text': task.isDone || $vuetify.theme.dark,
                                            'primary--text': !task.isDone && !$vuetify.theme.dark,
                                        }"
                                    > 
                                        <!-- {{
                                            // userTypeUser === userType.Developer ?
                                            // currentUserProjects.find(c => c.id === task.projectId)?.name :/
                                            // allProjects.find(c => c.id === task.projectId)?.name
                                        }} -->
                                    </span>
                                </v-col>
                                <v-col cols="5" class="py-0 text-end">
                                    <span>
                                        <span
                                            class="px-2 py-1 rounded-pill fs-11"
                                            :class="{ 
                                                'no-task-style-green bg-light-green': task.isDone,
                                                'bg-light-blue': !$vuetify.theme.dark && !task.isDone,
                                                'bg-light-grey white--text':  $vuetify.theme.dark && !task.isDone,
                                                'no-task-style': !task.isDone
                                            }"
                                        > 
                                            {{ task.taskNo }} 
                                        </span>
                                    </span>
                                </v-col>
                            </v-row>
                            <!-- text -->
                            <v-row>
                                <v-col class="text-start py-0 line-h-1-3">
                                    <!-- 'black--text': $vuetify.theme.dark && !task.isDone -->
                                    <span v-if="$vuetify.breakpoint.width < 1800" class="fs-12" 
                                        :class="{ 
                                            'white--text': task.isDone,	
                                        }"
                                        dir="auto"
                                    >
                                        {{	
                                            ( 
                                                (Number(((task.durationInMinute)/60).toFixed(2))) === 1 || 
                                                (Number(((task.durationInMinute)/60).toFixed(2))) < 2 
                                            ) ? 
                                            task.content.length > 35 ? (task.content.slice(0, 35) + '...'): task.content :

                                            (
                                                (Number(((task.durationInMinute)/60).toFixed(2))) === 2 || 
                                                (	(Number(((task.durationInMinute)/60).toFixed(2))) < 3 && 
                                                    ((((task.durationInMinute)/60).toFixed(2))) > 2
                                                ) 
                                            ) ? 
                                            task.content.length > 55 ? (task.content.slice(0, 55) + '...'): task.content  : 

                                            ( 
                                                (Number(((task.durationInMinute)/60).toFixed(2))) === 3 || 
                                                ( 
                                                    (Number(((task.durationInMinute)/60).toFixed(2))) < 4 && 
                                                    (Number(((task.durationInMinute)/60).toFixed(2))) > 3
                                                ) 
                                            )? 
                                            task.content.length > 68 ? (task.content.slice(0, 68) + '...'): task.content 

                                            : task.content.length > 70 ? (task.content.slice(0, 70) + '...') : task.content
                                        }}
                                    </span>

                                    <span v-if="$vuetify.breakpoint.width >= 1800" class="fs-12">
                                        
                                        {{	
                                            ( 
                                                (Number(((task.durationInMinute)/60).toFixed(2))) === 1 || 
                                                (Number(((task.durationInMinute)/60).toFixed(2))) < 2 
                                            ) ? 
                                            task.content.length > 60 ? (task.content.slice(0, 60) + '...'): task.content :

                                            (
                                                (Number(((task.durationInMinute)/60).toFixed(2))) === 2 || 
                                                (	(Number(((task.durationInMinute)/60).toFixed(2))) < 3 && 
                                                    (Number(((task.durationInMinute)/60).toFixed(2))) > 2
                                                ) 
                                            ) ? 
                                            task.content.length > 90 ? (task.content.slice(0, 90) + '...'): task.content  : 

                                            ( 
                                                (Number(((task.durationInMinute)/60).toFixed(2))) === 3 || 
                                                ( 
                                                    (Number(((task.durationInMinute)/60).toFixed(2))) < 4 && 
                                                    (Number(((task.durationInMinute)/60).toFixed(2))) > 3
                                                ) 
                                            )? 
                                            task.content.length > 100 ? (task.content.slice(0, 100) + '...'): task.content 

                                            : task.content.length > 115 ? (task.content.slice(0, 115) + '...') : task.content
                                        }}
                                    </span>
                                </v-col>
                            </v-row>
                            <v-row v-if="0">
                                <v-col cols="12" class="text-start py-0" align-self="end">
                                    <v-icon 
                                        size="15" 
                                        class="me-1" 
                                        :class="{
                                            'white--text': task.isDone
                                        }"
                                    > 
                                        mdi-clock-time-four-outline  
                                    </v-icon>
                                    <span v-if="task.isDone" class="fs-11 white--text">
                                        {{ ((task.actualDuration) / 60).toFixed(2) + ' h' }}
                                    </span>
                                    <span class="fs-11" :class="{'white--text': task.isDone}"> 
                                        / {{ task.durationInMinute / 60 }} h
                                    </span>
                                    
                                </v-col>
                            </v-row>
                            <!--  -->
                            <v-row class="">
                                <v-col align-self="end" cols="12" class=" py-1">
                                    <v-row justify="end">
                                        <v-col cols="auto" class="text-start" align-self="start">
                                            <v-icon 
                                                size="15" 
                                                class="me-1" 
                                                :class="{
                                                    'white--text': task.isDone
                                                }"
                                            > 
                                                mdi-clock-time-four-outline  
                                            </v-icon>
                                            <span class="fs-11" :class="{'white--text': task.isDone}"> 
                                                {{ task.durationInMinute / 60 }} h
                                            </span>
                                            <span v-if="task.isDone" class="fs-11 white--text">
                                                / {{ ((task.actualDuration) / 60).toFixed(2) + ' h' }}
                                            </span>
                                        </v-col>
                                        <v-spacer />
                                        <v-row 
                                            cols="auto" 
                                            align="center" 
                                            class=" py-0 d-flex"
                                            :class="{
                                                'justify-center': $vuetify.breakpoint.lg,
                                                'justify-end mx-1': $vuetify.breakpoint.mdAndDown
                                            }"
                                        >
                                            <v-btn	
                                                icon
                                                @click="taskId = task.id; dialog = true"
                                                :disabled="loading"
                                                color="edit-color"
                                            >
                                                <v-icon small> mdi-pencil </v-icon>
                                            </v-btn>

                                            <v-btn 
												v-if="0"
                                                icon 
                                                @click="taskId = task.id; view = true; dialog = true"
                                                x-small
                                            >
                                                <v-icon :color="task.isDone ? 'white' : 'edit-color'"> mdi-eye </v-icon>
                                            </v-btn>
                                        
                                            <v-btn
                                               
                                                :disabled="loading"
                                                icon
                                                @click="taskId = task.id; deleteDialog = true"
                                                color="alert-color"
                                            >
                                                <v-icon small> mdi-delete </v-icon>
                                            </v-btn>
                            
                                            <!-- <v-btn
                                                :disabled="loading"
                                                icon
                                                @click="taskId = task.id; status = task.isDone; task.doneLoading = true; changeToDone()"
                                                :color="task.isDone ? 'white' : 'green' "
                                                :loading="Boolean(task.doneLoading)"
                                            >
                                                <v-icon v-if="task.isDone"> mdi-swap-horizontal </v-icon>
                                                <v-icon v-if="!task.isDone" small> mdi-check-circle  </v-icon>
                                            </v-btn> -->
                                        </v-row>
                                    </v-row>
                                </v-col>
                            </v-row>
                        </v-col>
                        
                    </div>

					<v-btn
						v-if="
						((
							$route.params.id && 
							moment(moment(startDatePlan)).isSame(moment().format('YYYY-MM-DD'), 'day')
						) || 
						( 
							$route.params.id && 
							moment().isBefore(moment(startDatePlan).add(2, 'days'))
						)) &&
						day.tasks.map(c => c.durationInMinute).reduce((a, b) => a + b) / 60 <= 10 
						"
						class="align-self-center rounded-lg mx-2"
						width="3px"
						x-small
						height="80px"
						color="success-light white--text"
						@click="resetAll(); dialog = true"
						:disabled="loading"
					>
						<v-icon> mdi-plus </v-icon>	
					</v-btn>
				</v-col>
            </v-card-text>
        </v-card>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import { userType } from '@/helper/enum'
import rules from '@/helper/validation rules.js'

export default {
	watch: {
		dialog (val) {
			if (this.taskId) {
				const task = this.tasks.find(c => c.id === this.taskId)
				this.project = task?.projectId
				this.hours = task.durationInMinute ? Number((task?.durationInMinute / 60).toFixed(2)) : 0
				this.taskNo = task?.taskNo
				this.task = task?.content
			}
			if (!val) {
				this.rowId = null
				this.taskId = null
				this.project = null
				this.hours = 0
				this.taskNo = 0
				this.task = null
				this.$refs.form.reset()
				this.view = false
			}
		}
	},
	data () {
		return {
			userType,
			rules,
			tasks: [
				// {
				// 	id: '053b94c5-cc52-44a8-30e2-08dce5323ba7',
				// 	createdAt: '2024-10-05T11:38:29.1690774',
				// 	updatedAt: null,
				// 	planId: '932a9662-3d7a-414b-f747-08dce531910a',
				// 	projectId: 'e8dd2ee0-dcbd-4bc8-6527-08dcdd384001',
				// 	date: '2024-10-05T00:00:00',
				// 	content: 'push rowad al mustakbal dist to server',
				// 	durationInMinute: 30,
				// 	taskNo: 14183,
				// 	isDone: true,
				// 	actualDuration: 0
				// },
				// {
				// 	id: '8aadf381-0aed-4171-30e3-08dce5323ba7',
				// 	createdAt: '2024-10-05T11:49:41.8801153',
				// 	updatedAt: null,
				// 	planId: '932a9662-3d7a-414b-f747-08dce531910a',
				// 	projectId: '0ee2423e-cbc0-4db1-64da-08dcdd384001',
				// 	date: '2024-10-05T00:00:00',
				// 	content: 'planning to set plan to projects',
				// 	durationInMinute: 60,
				// 	taskNo: 0,
				// 	isDone: true,
				// 	actualDuration: 35
				// },
				// {
				// 	id: '72ff174d-5d9a-4d57-30e4-08dce5323ba7',
				// 	createdAt: '2024-10-05T11:50:42.0941249',
				// 	updatedAt: null,
				// 	planId: '932a9662-3d7a-414b-f747-08dce531910a',
				// 	projectId: 'f0f9870c-c135-44e3-657c-08dcdd384001',
				// 	date: '2024-10-05T00:00:00',
				// 	content: 'meeting with qamar to discuss new edits to ugarit after 1.5.5 communication',
				// 	durationInMinute: 60,
				// 	taskNo: 14279,
				// 	isDone: true,
				// 	actualDuration: 78
				// },
				// {
				// 	id: '9ddd7f51-9735-402d-30e5-08dce5323ba7',
				// 	createdAt: '2024-10-05T11:51:58.2673136',
				// 	updatedAt: null,
				// 	planId: '932a9662-3d7a-414b-f747-08dce531910a',
				// 	projectId: 'e8dd2ee0-dcbd-4bc8-6527-08dcdd384001',
				// 	date: '2024-10-05T00:00:00',
				// 	content: '(optional) push schools - meeting to fix core problem ',
				// 	durationInMinute: 60,
				// 	taskNo: 14275,
				// 	isDone: true,
				// 	actualDuration: 0
				// },
				// {
				// 	id: 'da3998c9-2e5e-404b-30e6-08dce5323ba7',
				// 	createdAt: '2024-10-05T11:52:51.2037623',
				// 	updatedAt: null,
				// 	planId: '932a9662-3d7a-414b-f747-08dce531910a',
				// 	projectId: '2f94ef39-f401-4b20-6592-08dcdd384001',
				// 	date: '2024-10-05T00:00:00',
				// 	content: 'planning to set al radwan edits and set task to the team',
				// 	durationInMinute: 30,
				// 	taskNo: 14274,
				// 	isDone: true,
				// 	actualDuration: 0
				// },
				{
					id: 'e8cbd481-72d4-4c87-30e7-08dce5323ba7',
					createdAt: '2024-10-05T11:53:33.158368',
					updatedAt: null,
					planId: '932a9662-3d7a-414b-f747-08dce531910a',
					projectId: '2f94ef39-f401-4b20-6592-08dcdd384001',
					date: '2024-10-05T00:00:00',
					content: 'al session',
					durationInMinute: 204,
					taskNo: 18979,
					isDone: false,
					actualDuration: 36
				},
				{
					id: 'e8cbd481-72d4-4c87-30e7-08dce5323ba7',
					createdAt: '2024-10-05T11:53:33.158368',
					updatedAt: null,
					planId: '932a9662-3d7a-414b-f747-08dce531910a',
					projectId: '2f94ef39-f401-4b20-6592-08dcdd384001',
					date: '2024-10-05T00:00:00',
					content: 'al radwan new edits after training session',
					durationInMinute: 222,
					taskNo: 1796,
					isDone: false,
					actualDuration: 50
				},
				{
					id: 'e8cbd481-72d4-4c87-30e7-08dce5323ba7',
					createdAt: '2024-10-05T11:53:33.158368',
					updatedAt: null,
					planId: '932a9662-3d7a-414b-f747-08dce531910a',
					projectId: '2f94ef39-f401-4b20-6592-08dcdd384001',
					date: '2024-10-05T00:00:00',
					content: 'al radwan new edits after training session',
					durationInMinute: 180,
					taskNo: 14269,
					isDone: false,
					actualDuration: 30
				}
			],
			dialog: false,
			project: null,
			taskNo: null,
			hours: 0,
			task: null,
			loading: false,
			taskId: null,
			view: false,
			deleteDialog: false,
			submitLoading: false,
			allProjects: []
		}
	},
	computed: {
		...mapState({
			userTypeUser: state => state.auth.self.userType
		})
	},
	methods: {
		addOrEditItemToRow () {
			this.tasks.push({
				content: this.task,
				taskNo: this.taskNo,
				durationInMinute: this.hours,
				projectId: this.project
			})
		},
		deleteTask ({ index }) {
			// this.tasks.splice(index, 1)
		}
	},

	created () {
		this.$store.dispatch('projects/fetchAll', { CategoryIds: [], UserId: [] })
	}
}
</script>
